<template>
    <b-modal ref="modal" centered scrollable hide-header hide-footer>
        <div class="project-delete">
            <div class="project-delete-description">
                <h2 tabindex="0">Are you sure you want to delete this project?</h2>
                <p tabindex="0">You can't undo this action.</p>
            </div>
            <div class="project-delete-action">
                <b-button @click="deleteProject()" variant="light">Yes, delete</b-button>
                <b-button @click="cancel()" variant="primary">No, cancel</b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {Project} from "../Utils";

    export default {
        name: "ProjectDeleteModal",
        props:{
            projectIndex: Number,
            projectId: [Number, String],
        },
        methods: {
            deleteProject() {
                Project.deleteProject(this.projectIndex, this.projectId).then(response => {
                    this.$refs.modal.hide()
                    this.$emit('close-delete-modal')
                }).catch(err => {
                    this.$refs.modal.hide()
                    this.$emit('close-delete-modal')
                })
            },
            cancel() {
                this.$refs.modal.hide()
                this.$emit('close-delete-modal')
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"

    .project-delete
        padding 20px 0

        & > *
            display flex
            flex 1

        &-description
            flex-direction column
            padding 15px 0

            & > *
                text-align center

            h2
                font font-poppins-semibold
                font-size 18px
                color color-black

            p
                font font-sourcesans-regular
                font-size 16px
                color color-4

        &-action
            flex-direction column

            .btn
                margin-top 15px
</style>